import { useRef } from 'react';

export const useTableScroll = () => {
    const tableRef = useRef<HTMLDivElement>(null);

    const scrollToTable = (position: 'top' | 'bottom') => {
        if (!tableRef.current) return;

        tableRef.current.scrollIntoView({
            behavior: 'smooth',
            block: position === 'top' ? 'start' : 'end',
        });
    };

    return { tableRef, scrollToTable };
};
